// src/router/router.js

import { createRouter, createWebHistory } from "vue-router";

import HomePage from "./components/HomePage.vue";
import ProgramsPage from "./pages/ProgramsPage.vue";
import AboutPage from "./pages/AboutPage.vue";
import DonatePage from "./pages/DonatePage.vue";
import ContactPage from "./pages/ContactPage.vue";
import OurSocialsPage from "./pages/OurSocialsPage.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: { title: "Mary Chan • Bridge of Hope" },
  },

  {
    path: "/programs",
    name: "programs",
    component: ProgramsPage,
    meta: { title: "Programs • Mary Chan" },
  },

  {
    path: "/about",
    name: "about",
    component: AboutPage,
    meta: { title: "About Us • Mary Chan" },
  },

  {
    path: "/donate",
    name: "donate",
    component: DonatePage,
    meta: { title: "Donate • Mary Chan" },
  },

  {
    path: "/donate/success",
    name: "donate-success",
    component: DonatePage,
    meta: { title: "Donation Successful • Mary Chan" },
  },

  {
    path: "/contact",
    name: "contact",
    component: ContactPage,
    meta: { title: "Contact • Mary Chan" },
  },

  {
    path: "/social",
    name: "social",
    component: OurSocialsPage,
    meta: { title: "Social • Mary Chan" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    return {
      top: 0,
      left: 0,
      behavior: "smooth",
    };
  },
});

router.afterEach((to) => {
  const base = "Mary Chan • Bridge of Hope";

  document.title = to.meta?.title ? String(to.meta.title) : base;
});

export default router;
